import React from "react";
import MyNavbar from "../../Shear/MyNavbar/MyNavbar";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import HomeBlog from "../HomeBolg/HomeBlog";
import HomeContact from "../HomeContact/HomeContact";
import HomeProject from "../HomeProject/HomeProject";

const Home = () => {
  return (
    <main>
      <MyNavbar />
      <Header />
      <HomeProject />
      <HomeBlog />
      <HomeContact />
      <Footer />
    </main>
  );
};

export default Home;
